// import Vue from 'vue'

window.Cookie = require('js-cookie');
window.Velocity = require('velocity-animate');
// window.Vue = Vue

require('waypoints/lib/noframework.waypoints.min.js');

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.header = document.getElementById('header');
window.headerHeight = header.offsetHeight;
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.navwrap = document.getElementById('nav-wrap');
window.popupMenu = document.getElementById('popup-menu');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token)
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
else
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
    return window.innerWidth < width;
};

/*=============================
=        Keyboard Focus       =
=============================*/

document.addEventListener('keydown', function(e) {
    if(e.keyCode == 9 && !body.classList.contains('tabbing'))
        body.classList.add('tabbing');
});

document.addEventListener('mousedown', function() {
    if(body.classList.contains('tabbing'))
        body.classList.remove('tabbing');
});

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
    var scriptWaypoint = new Waypoint({
        element: el,
        handler: function(direction) {
            addJS(src);

            this.destroy();
        },
        offset: offset
    });
};

window.addJS = function addJS(src) {
    var script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');

    document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
    Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeight + 100)});
};

/*=============================
=           Set Focus         =
=============================*/

// Removes focus() on elements when the modal is open

window.setFocus = function setFocus(open, container) {
    [].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
        if(parent != container) {
            parent.setAttribute('aria-hidden', open);

            [].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
                if(open)
                    link.setAttribute('tabindex', '-1');
                else
                    link.removeAttribute('tabindex');
            });
        }
    });
}

/*=============================
=        Skip to Content      =
=============================*/

var skipLink = document.getElementById('skip-link');

skipLink.addEventListener('click', function(e) {
    e.preventDefault();

    var firstLink = document.querySelector('#hero a, main a');

    if(firstLink) {
        scrollToElement(firstLink);
        firstLink.focus();
    }
});

window.skipLinkToggleDisplay = function skipLinkToggleDisplay(hide) {
    skipLink.style.display = hide ? 'none' : '';
}

/*=============================
=       Google Map Styles     =
=============================*/

// window.mapStyles = [
// ];

/*=============================
=       Newsletter Modal     =
=============================*/

let newsletterOpenModal = document.getElementById('modal-news-open');
let newsletterCloseModal = document.getElementById('modal-news-close');
let modal = document.getElementById('newsletter-overlay');

newsletterOpenModal.addEventListener("click", function(){

    modal.classList.add('open');

});

newsletterCloseModal.addEventListener("click", function(){

    modal.classList.remove('open');

});

/*=============================
=       Wechat Modal     =
=============================*/
let wechatOpenModal = document.querySelector(".social-media .wechat");
let wechatCloseModal = document.getElementById("modal-wechat-close");
let wechatModal = document.querySelector(".wechat-overlay");

wechatOpenModal.addEventListener("click", function (e) {
    e.preventDefault();
    wechatModal.classList.add("open");
});

wechatCloseModal.addEventListener("click", function () {
    wechatModal.classList.remove("open");
});
